import { useLanguage } from "../i18n/LanguageContext";
import VisitorStats from "./VisitorStats";
import "./Footer.css";

export default function Footer() {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer className="footer" role="contentinfo">
      <VisitorStats />
      <p className="footer-tagline">{t.footer.tagline}</p>
      <p className="footer-text">
        &copy; {year} {t.footer.copyright}
      </p>
    </footer>
  );
}
